import type { PendingShopifyIntegrationCookie } from "schemas/cookies";

import * as React from "react";

import useCurrentUser from "@v2/hooks/useCurrentUser";
import { useLogAnalytics } from "@v2/hooks/useLogAnalytics";
import usePendingShopifyIntegrationCookie from "@v2/hooks/usePendingShopifyIntegrationCookie";
import { SHOPIFY_APP_LISTING_URL } from "@v2/utils/env";

export type V2PendingShopifyIntegrationCookie = Extract<
  PendingShopifyIntegrationCookie,
  {
    type:
      | "onboarding"
      | "home"
      | "sections"
      | "noShopifyErrorModal"
      | "projectSettings"
      | "newProject"
      | "publish"
      | "shopStyles"
      | "preview"
      | "assets"
      | "productPicker"
      | "billingModal"
      | "shopSettingsIntegration"
      | "agentIntegrations"
      | "projectView"
      | "analytics"
      | "abtesting";
  }
>;

const useInstallShopify = () => {
  const { setPendingShopifyIntegrationCookie } =
    usePendingShopifyIntegrationCookie();
  const analytics = useLogAnalytics();
  const { user } = useCurrentUser();

  return React.useCallback(
    ({ cookie }: { cookie: V2PendingShopifyIntegrationCookie }) => {
      setPendingShopifyIntegrationCookie(cookie);

      analytics("shopify.connect", {
        userId: user?.email ?? "",
        source: cookie.type,
      });

      window.location.href = SHOPIFY_APP_LISTING_URL;
    },
    [setPendingShopifyIntegrationCookie, analytics, user],
  );
};

export default useInstallShopify;
